// @internal
import styled, { css } from 'styled-components';
import { StyledSideNavProps } from '../../styles';
import { sidenavTokens } from '../../../../tokens/components/SideNav/tokens';
import { SideNavStickyContainerProps } from './SideNavStickyContainer';

type StyledSideNavStickyContainerProps = Pick<StyledSideNavProps, 'isClosed'> &
  Pick<SideNavStickyContainerProps, 'position' | 'justify' | 'hideFilter'> & {
    isScrolling: boolean;
  };

export const StyledSideNavStickyContainer = styled.div<StyledSideNavStickyContainerProps>`
  align-items: center;
  background-color: ${({ position, hideFilter }) =>
    position === 'top' && hideFilter ? 'transparent' : sidenavTokens.WrapperColorBackgroundBaseDefault};
  display: ${({ isClosed }) => (isClosed ? 'block' : 'flex')};
  flex-direction: row;
  gap: ${sidenavTokens.ItemSpacingGapHorizontalBaseDefault};
  justify-content: ${({ isClosed, justify }) => (isClosed ? 'center' : justify)};

  transition: ${`margin ${sidenavTokens.TransitionDurationBaseDefault} ${sidenavTokens.TransitionCurveBaseDefault},
        border-bottom ${sidenavTokens.TransitionDurationBaseDefault} ${sidenavTokens.TransitionCurveBaseDefault},
        box-shadow ${sidenavTokens.TransitionDurationBaseDefault} ${sidenavTokens.TransitionCurveBaseDefault},
        top ${sidenavTokens.TransitionDurationBaseDefault} ${sidenavTokens.TransitionCurveBaseDefault}
        `};

  ${({ position, hideFilter, isClosed, isScrolling }) =>
    hideFilter
      ? css`
          ${position === 'top'
            ? css`
                position: absolute;
                height: max-content;
                margin: 0 0 8px;
                top: ${isClosed ? '16px' : '8px'};
                padding: 4px 16px;
              `
            : css`
                position: sticky;
                height: auto;
                padding: auto;
                justify-self: ${position === 'bottom' ? 'end' : 'start'};
              `}
        `
      : css`
          ${position === 'top'
            ? css`
                border-bottom: ${isScrolling
                  ? sidenavTokens.StickyContainerBorderBaseVisible
                  : sidenavTokens.StickyContainerBorderBaseHidden};

                box-shadow: ${isScrolling
                  ? `${sidenavTokens.StickyContainerBoxShadowOffsetXBaseVisible} ${sidenavTokens.StickyContainerBoxShadowOffsetYBaseVisible} ${sidenavTokens.StickyContainerBoxShadowBlurBaseVisible} ${sidenavTokens.StickyContainerBoxShadowColorBaseVisible}`
                  : `${sidenavTokens.StickyContainerBoxShadowOffsetXBaseHidden} ${sidenavTokens.StickyContainerBoxShadowOffsetYBaseHidden} ${sidenavTokens.StickyContainerBoxShadowBlurBaseHidden} ${sidenavTokens.StickyContainerBoxShadowColorBaseHidden}`};

                height: ${sidenavTokens.StickyContainerTopHeightBaseDefault};
                top: ${isClosed ? '0' : 'auto'};
                padding: ${sidenavTokens.StickyContainerTopPaddingBaseDefaultVertical}
                  ${sidenavTokens.StickyContainerTopPaddingBaseDefaultHorizontal};
              `
            : css`
                height: auto;
                padding: 0;
              `}
        `}

  ${({ position }) => css`
    ${position === 'top' &&
    css`
      right: 0;
    `}

    ${position === 'bottom' &&
    css`
      border-top: ${sidenavTokens.StickyContainerBorderBaseVisible};
      bottom: 0;
    `}
  `}
`;
